import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Check: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--check')}
    width="11"
    height="12"
    viewBox="0 0 11 12"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g
      strokeWidth="2"
      stroke="#696969"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <path d="M1 7l3.37 3.526M9.28 1.36l-5.035 9.22" />
    </g>
  </svg>
);

export default Check;
